import { render, staticRenderFns } from "./CBoard.vue?vue&type=template&id=24e1ccb0&scoped=true"
import script from "./CBoard.vue?vue&type=script&lang=js"
export * from "./CBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e1ccb0",
  null
  
)

export default component.exports